import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'

const HomeSocials = () => {
  return (
    <div className='header_socials'>
        <a href="https://linkedin.com/in/iamkrishhna" target='_blank'> <BsLinkedin/> </a>
        
        <a href="https://github.com/i-am-Krishna" target='_blank'> 
        <FaGithub/>
        </a>

    </div>
  )
}

export default HomeSocials